import { QB_FIELD_TYPES, QB_OPERATOR_TYPES } from './types.js';

var QB_DEFAULT_VALUES_OPTIONS = [{
  label: 'Choose a Field',
  value: ''
}];
var QB_SUBJECT_VALUES_OPTIONS = [{
  label: 'Condominium',
  value: 'Condominium'
}, {
  label: 'Single Family Home',
  value: 'Single Family Home'
}, {
  label: 'Co-Operative',
  value: 'Co-Operative'
}, {
  label: 'Detached',
  value: 'Detached'
}, {
  label: 'High Rise Condominium',
  value: 'High Rise Condominium'
}, {
  label: 'Manufactured Housing',
  value: 'Manufactured Housing'
}, {
  label: 'Other',
  value: 'Other'
}];
var QB_LOAN_VALUES_OPTIONS = [{
  label: 'Conventional',
  value: 'Conventional'
}, {
  label: 'VA',
  value: 'VA'
}, {
  label: 'FHA',
  value: 'FHA'
}, {
  label: 'USAD-RHS',
  value: 'USAD-RHS'
}, {
  label: 'HELOC',
  value: 'HELOC'
}, {
  label: 'Other',
  value: 'Other'
}];
var QB_FIELD_OPTIONS = [{
  label: 'Select',
  value: ''
}, {
  label: 'Loan Type',
  value: QB_FIELD_TYPES.LOAN_VALUES
}, {
  label: 'Loan To Value (LTV)',
  value: QB_FIELD_TYPES.LTV_VALUES
}, {
  label: 'Subject Property Type',
  value: QB_FIELD_TYPES.SUBJECT_VALUES
}, {
  label: 'Last Finished Milestone',
  value: QB_FIELD_TYPES.LAST_VALUES
}, {
  label: 'Credit Score',
  value: QB_FIELD_TYPES.CREDIT_VALUES
}];
var QB_OPERATOR_OPTIONS = [{
  label: 'Select',
  value: ''
}, {
  label: 'Is',
  value: QB_OPERATOR_TYPES.EQUAL
}, {
  label: 'Is not',
  value: QB_OPERATOR_TYPES.NOT_EQUAL
}, {
  label: 'Greater than',
  value: QB_OPERATOR_TYPES.GREATER_THAN
}, {
  label: 'Less than',
  value: QB_OPERATOR_TYPES.LESS_THAN
}, {
  label: 'Contains',
  value: QB_OPERATOR_TYPES.CONTAINS
}, {
  label: "Doesn't Contain",
  value: QB_OPERATOR_TYPES.NOT_CONTAINS
}, {
  label: 'Between',
  value: QB_OPERATOR_TYPES.BETWEEN
}];

export { QB_DEFAULT_VALUES_OPTIONS, QB_FIELD_OPTIONS, QB_LOAN_VALUES_OPTIONS, QB_OPERATOR_OPTIONS, QB_SUBJECT_VALUES_OPTIONS };
//# sourceMappingURL=selectors.js.map
